import Quote from "./Quote";
import AppConstants from "../util/AppConstants";
import TickManager, {TempTick} from "../service/TickManager";
import {GenInfo} from "./GenInfo";
import {SGBMarket} from "./SGBMarket";
import {Combo} from "./Combo";
import {OHLC} from "./OHLC";
import {Circuits} from "./Circuits";
import {MiniTick} from "./MiniTick";

export interface Option {
    itm: boolean,
    genInfo: GenInfo,
    circuits: Circuits,
    miniTick: MiniTick,
    extrinsicSell: number,
    extrinsicBuy: number,
    intrinsic: number,
    diff: number,
    token: number,
}


export interface OptionsMapping{
    options: Array<Option>,
    // first is call option to corresponding put option
    mappings: Array<Pair<string,string|null>>
}

export class OptionWrapper{

    constructor(public option:Option) {
    }

    getIntrinsic(fut:number){
        if (this.option.genInfo.instrument_type===AppConstants.PE){
            return Math.max(this.option.genInfo.strike - fut, 0)
        }
        if (this.option.genInfo.instrument_type===AppConstants.CE){
            return Math.max(fut - this.option.genInfo.strike, 0)
        }
        return fut
    }
    getIntrinsicVal(){
        let fut = TickManager.getFuture(this.option.genInfo.tradingsymbol)
        if (fut===null){return 0.0}
        this.getIntrinsic(fut.miniTick.lastPrice)
    }


}


export interface Tick1 {
    source: string,
    ohlc: OHLC,
    buy:Array<Quote>,
    sell:Array<Quote>,
    last_traded_quantity: number,
    last_trade_time: number,
    average_traded_price: number,
    volume_traded: number,
    last_price: number,
    timestamp: number,
    token: number,
}

export interface SGB {
    isin: string,
    genInfo: GenInfo
    link: string,
    circuits: Circuits,
    upperCircuit: number,
    goldPrice: number,
    tick: Tick1,
}

export interface EquityMarket {
    tradingsymbol:string
    last_price:number
    currentTime:number
    buy:Array<Quote>
    sell:Array<Quote>
}


export interface Ticks{
    all(data: Array<SGBMarket>): void
    onSGBFeed(data: Array<SGBMarket>): void
    onEquityFeed(data: Array<EquityMarket>): void
    congratulations(): void;
    hurry(): void;
    onOptionsFeed(options: Array<Option>): void;
    onTickFeed(tick:TempTick): void;
}


export interface Combo1 extends Combo{
    // FIXME
    calcText: string;
    calcTextA: string;
    calc: number;
    symbols: string;
    minProfitA: number;
}


export interface Charges{
    margin:number,
    span:number,
    exposure:number,
    charges:number
}


export interface Pair<K,V>{
    first:K,
    second:V,
}

